import { useAbility as useCaslAbility } from '@casl/react';
import { AbilityContext } from '../contexts/AbilityContext';

export function useAbility() {
  return useCaslAbility(AbilityContext);
}
